import React from 'react';
import { HStack, Text, Circle } from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';

/**
 * RemixBadge - Shows "Remixed!" status with checkmark icon
 * Used in agenda cards to indicate when an agenda has been remixed
 */
const RemixBadge = ({
  visible = true,
  text = "Remixed!",
  size = 'sm',
  variant = 'default',
  ...props
}) => {
  if (!visible) return null;

  const sizes = {
    sm: {
      fontSize: '11px',
      iconSize: '16px',
      spacing: '3px',
    },
    md: {
      fontSize: '12px',
      iconSize: '18px', 
      spacing: '4px',
    },
  };

  const variants = {
    default: {
      textColor: '#726682',
      iconBg: '#32D583',
      iconColor: 'white',
    },
    success: {
      textColor: '#32D583',
      iconBg: '#32D583',
      iconColor: 'white',
    },
  };

  const sizeProps = sizes[size] || sizes.sm;
  const variantProps = variants[variant] || variants.default;

  return (
    <HStack
      spacing={sizeProps.spacing}
      align="center"
      transition="all 0.2s"
      _hover={{
        transform: 'translateY(-1px)',
      }}
      {...props}
    >
      <Text
        fontSize={sizeProps.fontSize}
        fontWeight="400"
        color={variantProps.textColor}
        lineHeight="1.455"
        letterSpacing="-1%"
        fontFamily="Geist, sans-serif"
        mr={1}
      >
        {text}
      </Text>
      <Circle
        size={sizeProps.iconSize}
        bg={variantProps.iconBg}
        display="flex"
        alignItems="center"
        justifyContent="center"
        transition="all 0.2s"
        _hover={{
          transform: 'scale(1.1)',
        }}
      >
        <FiCheck 
          size="10px" 
          color={variantProps.iconColor}
          strokeWidth="2.5px"
        />
      </Circle>
    </HStack>
  );
};

export default RemixBadge;
